export default __webpack_public_path__ + "static/media/payment-method-gg.aaf4626f.svg";